import { Expose } from "class-transformer";
import { IsNumber, IsOptional } from "class-validator";

export default class MarketOrderStatus {
  @IsNumber()
  @IsOptional()
  @Expose({ name: 'prestashop_waiting_payment_state_id' })
  readonly prestashopWaitingPaymentStateId?: number;

  @IsNumber()
  @IsOptional()
  @Expose({ name: 'prestashop_payment_failed_state_id' })
  readonly prestashopPaymentFailedStateId?: number;

  @IsNumber()
  @IsOptional()
  @Expose({ name: 'prestashop_paid_state_id' })
  readonly prestashopPaidStateId?: number;

  @IsNumber()
  @IsOptional()
  @Expose({ name: 'prestashop_canceled_state_id' })
  readonly prestashopCanceledStateId?: number;

  constructor(init?: MarketOrderStatus) {
    this.prestashopCanceledStateId = init?.prestashopCanceledStateId;
    this.prestashopPaidStateId = init?.prestashopPaidStateId;
    this.prestashopPaymentFailedStateId = init?.prestashopPaymentFailedStateId;
    this.prestashopWaitingPaymentStateId = init?.prestashopWaitingPaymentStateId;
  }
}
